type PawProps = React.SVGProps<SVGSVGElement> & { pathFill?: "url(#gradient)" | "currentColor" };

const Paw = (props: PawProps) => {
  const { pathFill = "url(#gradient)", ...other } = props;

  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <linearGradient id="gradient" x2="1" y2="1">
        <stop offset="0%" stopColor="#28a9e2" />
        <stop offset="100%" stopColor="#2498cb" />
      </linearGradient>
      <path
        d="M11.5829 26.8497C7.49116 26.8319 0.106509 27.6929 0 34.0835C0 37.9799 2.29883 41.5036 5.8669 43.0746C6.92311 43.545 8.03259 43.8823 9.17756 44.0776C13.0829 44.7522 14.6628 46.3498 15.2397 47.1841C15.5681 47.6812 15.9498 48.1516 16.367 48.5865C18.3995 50.6013 23.6806 55.3232 27.2309 53.6368C31.7043 51.5155 33.5505 49.4918 33.5505 44.6634C33.5505 39.835 30.7191 38.7699 30.7191 35.9474C30.7191 33.1249 33.7901 26.539 28.7309 23.2373C24.9321 20.7609 20.2545 23.2816 16.9705 25.3142C15.3551 26.3171 13.4823 26.8586 11.5829 26.8497Z"
        fill={pathFill}
      />
      <path
        d="M47.6466 40.6764C51.1836 38.0809 52.4946 33.856 50.5748 31.2398C48.655 28.6236 44.2314 28.6068 40.6944 31.2023C37.1573 33.7978 35.8463 38.0227 37.7661 40.6389C39.6859 43.2551 44.1096 43.2719 47.6466 40.6764Z"
        fill={pathFill}
      />
      <path
        d="M45.1437 24.9109C49.0562 22.0399 50.5093 17.3706 48.3894 14.4817C46.2695 11.5928 41.3793 11.5783 37.4669 14.4493C33.5545 17.3203 32.1013 21.9896 34.2212 24.8785C36.3411 27.7674 41.2313 27.7819 45.1437 24.9109Z"
        fill={pathFill}
      />
      <path
        d="M33.2307 11.2181C34.2702 6.47779 32.4229 2.04509 29.1046 1.31744C25.7864 0.589788 22.2537 3.84273 21.2142 8.58309C20.1747 13.3234 22.022 17.7561 25.3403 18.4838C28.6585 19.2114 32.1912 15.9585 33.2307 11.2181Z"
        fill={pathFill}
      />
      <path
        d="M16.9359 15.1094C17.8756 10.8239 16.2037 6.81619 13.2015 6.15784C10.1992 5.49949 7.00362 8.43985 6.06387 12.7253C5.12412 17.0108 6.79609 21.0186 9.79832 21.6769C12.8005 22.3353 15.9961 19.3949 16.9359 15.1094Z"
        fill={pathFill}
      />
    </svg>
  );
};

export default Paw;
